"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGenericConfigByType = exports.getConfigByType = void 0;
var Chevron_1 = __importDefault(require("Public/Widgets/Chevron"));
var server_1 = __importDefault(require("react-dom/server"));
var react_1 = __importDefault(require("react"));
var makeConfig = function (config) { return config; };
var configs = [
    makeConfig({
        type: "chevron",
        tokenType: {},
        publicRender: function (token) { var _a; return server_1.default.renderToString(react_1.default.createElement(Chevron_1.default, { clickToScroll: (_a = token.clickToScroll) !== null && _a !== void 0 ? _a : true })); },
    }),
];
var getConfigByType = function (type) {
    var e_1, _a;
    try {
        for (var configs_1 = __values(configs), configs_1_1 = configs_1.next(); !configs_1_1.done; configs_1_1 = configs_1.next()) {
            var config = configs_1_1.value;
            if (config.type === type) {
                return config;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (configs_1_1 && !configs_1_1.done && (_a = configs_1.return)) _a.call(configs_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return undefined;
};
exports.getConfigByType = getConfigByType;
var getGenericConfigByType = function (type) { return (0, exports.getConfigByType)(type); };
exports.getGenericConfigByType = getGenericConfigByType;
